import { IGetState, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { fetchHandler } from '../../../../../../../../util/fetchHandler';
import { REST_CARDS_ASSIGNED_TO_ME, REST_MY_WORK } from '../../../../../../../../rest/constants';
import { getRestHeadersPost } from '../../../../../../../../rest/helpers/getRestHeadersHelper';
import { Util } from '../../../../../../../../util/util';

export const restPost = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<any>(
            Util.getApiUrl(REST_CARDS_ASSIGNED_TO_ME + '/' + cardId + '/' + REST_MY_WORK), {
                ...getRestHeadersPost()
            }
        );
    };
    return action;
};
